import { useCallback } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { ConfirmDialog } from 'core-components/library/confirmDialog'
import { BaseCrud } from 'core-components/types'

interface IDeleteItemContentModal {
  item: IForm
  keyField: string | undefined
  source: BaseCrud
  onClose: () => void
}

export const DeleteItemContentModal = ({
  item,
  keyField,
  source,
  onClose,
}: IDeleteItemContentModal) => {
  const deleteHandler = useCallback(async () => {
    // @ts-ignore
    const formId = source.fetcher.spec.formId as string
    await source.delete(formId, item)
  }, [item, source])

  return (
    <ConfirmDialog
      show={!!item}
      hideTitle={true}
      onClose={onClose}
      onAction={deleteHandler}
      textQuestion={`Do you want remove item [#${keyField ? item[keyField] : item.EntryId}]?`}
      textButton={'Delete'}
    />
  )
}
